import type { Module } from "vuex";

interface SpecService {
  id: number;
  name: string;
  time: string;
  pricePln: string;
  priceStartsFrom: boolean;
}

interface ClinicSpec {
  name: string;
  services: SpecService[];
}

export interface ModifyServiceArgs {
  newValue: SpecService;
  specIdx: number;
}

export interface AuthClinicState {
  form: {
    name: string;
    surname: string;
    position: string;
    entityRegisterNumber: string;
    phoneNumber: string;
    email: string;
    password: string;
    password_confirm: string;
    accept_terms: boolean;
    accept_marketing: boolean;
    agree_contact: boolean;
  };
  clinicName: string;
  clinicSpecs: ClinicSpec[];
}

const module: Module<AuthClinicState, unknown> = {
  namespaced: true,
  state: {
    form: {
      name: "",
      surname: "",
      position: "",
      entityRegisterNumber: "",
      phoneNumber: "",
      email: "",
      password: "",
      password_confirm: "",
      accept_marketing: false,
      accept_terms: false,
      agree_contact: false,
    },
    clinicName: "",
    clinicSpecs: [
      {
        name: "Internista",
        services: [
          {
            id: 0,
            name: "Omówienie badań",
            time: "00:30",
            pricePln: "50",
            priceStartsFrom: false,
          },
          {
            id: 1,
            name: "Leczenie kanałowe",
            time: "02:00",
            pricePln: "300",
            priceStartsFrom: true,
          },
          {
            id: 2,
            name: "Leczenie próchnicy",
            time: "00:40",
            pricePln: "100",
            priceStartsFrom: false,
          },
          {
            id: 3,
            name: "Wypełnienie kompozytowe",
            time: "01:30",
            pricePln: "80",
            priceStartsFrom: false,
          },
          {
            id: 4,
            name: "Leczenie próchnicy",
            time: "00:20",
            pricePln: "50",
            priceStartsFrom: false,
          },
        ],
      },
      {
        name: "Pediatra",
        services: [
          {
            id: 0,
            name: "Omówienie badań",
            time: "00:30",
            pricePln: "50",
            priceStartsFrom: false,
          },
          {
            id: 1,
            name: "Leczenie kanałowe",
            time: "02:00",
            pricePln: "300",
            priceStartsFrom: true,
          },
          {
            id: 2,
            name: "Leczenie próchnicy",
            time: "00:40",
            pricePln: "100",
            priceStartsFrom: false,
          },
          {
            id: 3,
            name: "Wypełnienie kompozytowe",
            time: "01:30",
            pricePln: "80",
            priceStartsFrom: false,
          },
          {
            id: 4,
            name: "Leczenie próchnicy",
            time: "00:20",
            pricePln: "50",
            priceStartsFrom: false,
          },
        ],
      },
    ],
  },
  getters: {
    getFormState: (state) => state.form,
    getSpecs: (state) => state.clinicSpecs,
  },
  mutations: {
    setForm(state, updated: Partial<AuthClinicState["form"]>) {
      Object.assign(state.form, updated);
    },
    addService(state, { newValue, specIdx }: ModifyServiceArgs) {
      if (!state.clinicSpecs[specIdx]) return;

      newValue.id = state.clinicSpecs[specIdx].services.length;
      state.clinicSpecs[specIdx].services.push(newValue);
    },
    editService(state, { newValue, specIdx }: ModifyServiceArgs) {
      if (!state.clinicSpecs[specIdx]) return;

      const selectedServices = state.clinicSpecs[specIdx].services;

      const editedIdx = selectedServices.findIndex((x) => {
        return x.id === newValue.id;
      });
      if (!selectedServices[editedIdx]) return;

      state.clinicSpecs[specIdx].services[editedIdx] = newValue;
    },
    deleteService(state, { id, specIdx }: { specIdx: number; id: number }) {
      if (!state.clinicSpecs[specIdx]) return;

      state.clinicSpecs[specIdx].services = state.clinicSpecs[
        specIdx
      ].services.filter((x) => x.id !== id);
    },
  },
};

export default module;
